import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface KnowledgeLibraryFile {
  id: number;
  display_name: string;
  file_name: string;
  file_type: string;
  file_size: number;
  created_at?: string;
  uploaded_by_user_id: number;
}

@Injectable({
  providedIn: 'root'
})
export class KnowledgeLibraryService {
  private domain = environment.domain;

  constructor(private http: HttpClient) { }

  listFiles() {
    return this.http.get<any>(`${this.domain}knowledge-library/files`);
  }

  downloadFile(id: number) {
    return this.http.get(`${this.domain}knowledge-library/files/${id}/download`, { responseType: 'blob' });
  }

  uploadFile(name: string, file: File) {
    const form = new FormData();
    form.append('name', name);
    form.append('file', file);
    return this.http.post<any>(`${this.domain}knowledge-library/files`, form);
  }

  softDelete(id: number) {
    return this.http.delete<any>(`${this.domain}knowledge-library/files/${id}`);
  }
}

